import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TeamRecommendationList from './TeamRecommendationList';
import TeamRecommendation from './TeamRecommendationDetails';

function TeamRecommendationIndex() {
  return (
    <>
      <Routes>
        <Route path="/" element={<TeamRecommendationList />} />
        <Route path="details/:id" element={<TeamRecommendation />} />
        <Route path="details/create" element={<TeamRecommendation />} />
      </Routes>
    </>
  );
}

export default TeamRecommendationIndex;
